import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'

export default function Pairing(){
  return (
    <div className="pageStyles pairing">
      <Helmet>
        <title>Wine Pairing Events at Villaggio Grille</title>
        <meta name="description" content="Every month, Villaggio Grille hosts a wine dinner showcasing a different vineyard. With the amazing dishes they create to accompany each wine, every dinner becomes a four-course experience that your taste buds will thank you for." />
      </Helmet>

      <div className="events-listing-page custStylePTA">
        <div id="page-title" className="pt-bkg-image image-events">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="title-container less">
                  <h1>November Wine Pairing</h1>
                  <h4 className="one">
                    November 20th &nbsp;&middot;&nbsp; 6pm 
                    <span className="rules"> &nbsp;&middot;&nbsp; </span>
                    <br className="rules" />
                    $60 per guest
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container food-menus no-padding">
            <div className="intro">
              <p className="res">For Reservations: <span><PhoneLink /></span></p>
            </div>
            <div className="clearfix"></div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>
            
            <div className="course">
              <div className="service-box-2">
                <h3>Course One</h3>
                <h4>Foie Gras Baked Oysters</h4>
                <h5>Bon Secour Oysters, Pan Seared Foie Gras, Topped with Citrus Ginger Beurre Blanc</h5>
                <p>Paired with</p>
                <h4>Corvidae "Wise Guy" · Sauvignon Blanc · Columbia Valley, WA</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Two</h3>
                <h4>Chimichurri Skirt Steak</h4>
                <h5>Bell Peppers, Zucchini, Baked Sweet Potato</h5>
                <p>Paired with</p>
                <h4>North By Northwest · Red Blend · Columbia Valley, WA '19</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Three</h3>
                <h4>Mushroom And Leek Lasagna</h4>
                <h5>10 Layers, Ricotta Béchamel Cream, Sautéed Oyster Mushroom and Leek</h5>
                <p>Paired with</p>
                <h4>Gravel Bar Winery · Red Mountain Merlot · Columbia Valley, WA</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Four</h3>
                <h4>Apple Strudel Almond Cake</h4>
                <h5>Almond Cake, Apple Strudel Mixture</h5>
                <p>Paired with</p>
                <h4>Argyle Winery · Blanc de Blancs · Willamette Valley '20</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
